import { NgModule } from '@angular/core';
import { MatAutocompleteModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatProgressSpinnerModule, MatRadioModule } from '@angular/material';
import { SharedModule } from "@app/shared";
import {
  NewAddressPopupComponent
} from '@sales/components/task-management';
@NgModule({
  declarations: [NewAddressPopupComponent],
  imports: [
    SharedModule, MatIconModule, MatDialogModule, MatProgressSpinnerModule, MatRadioModule,
    MatFormFieldModule, MatAutocompleteModule,MatButtonModule
  ],
  exports: [],
  providers: [],
  entryComponents: [NewAddressPopupComponent]
})
export class NewAddressModule { }
